const faq = [
  {
    id: '5fa5cbbb-f6b7-4ca3-bf64-86e6909832b7',
    link: '',
    answer:
      'Somos uma empresa de gestão e administração de créditos. Esses créditos podem ser de bancos, financeiras, lojas de varejo, prestadores de serviços, concessionárias de serviços públicos ou privados, entre outros ramos de atividades. A Recovery trabalha com objetivo de realizar negociações sustentáveis e que sejam boas para ambas as partes.',
    answers: [
      {
        id: 'c38c7b00-8d00-4e8a-bf44-d6aa9291428c',
        link: '',
        answer:
          'Somos uma empresa de gestão e administração de créditos. Esses créditos podem ser de bancos, financeiras, lojas de varejo, prestadores de serviços, concessionárias de serviços públicos ou privados, entre outros ramos de atividades. A Recovery trabalha com objetivo de realizar negociações sustentáveis e que sejam boas para ambas as partes.',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
    ],
    question: 'O que é Recovery?',
    component: 'faq',
    text_link: '',
    data_unique: '769e78c4-8dc5-4eb4-872c-ba2054b52663',
    answer_markdown: '',
    answer_after_link: '',
  },
  {
    id: 'fb80327b-9d7e-49f5-8efa-df1ee9a5e72e',
    link: '',
    answer:
      'Por meio de uma cessão de crédito, o Fundo de Investimento em Direitos Creditórios adquire o direito de cobrança e recebimento da dívida de consumidores em débito com instituições financeiras ou varejistas, e hoje essas dívidas são administradas pela Recovery.',
    answers: [
      {
        id: 'cf0ad641-ccff-473a-aabd-8f495bb955a7',
        link: '',
        answer:
          'Por meio de uma cessão de crédito, o Fundo de Investimento em Direitos Creditórios adquire o direito de cobrança e recebimento da dívida de consumidores em débito com instituições financeiras ou varejistas, e hoje essas dívidas são administradas pela Recovery.',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
    ],
    question: 'O que é Fundo de Investimento em Direitos Creditórios?',
    component: 'faq',
    text_link: '',
    data_unique: '5c5f8e6e-9b6d-4684-a5b2-2b5d37393921',
    answer_markdown: '',
    answer_after_link: '',
  },
  {
    id: 'cac13a9b-da0e-4c3e-b41a-c9c702449281',
    link: '',
    answer:
      'Durante o período do Saldão Recovery, você tem a oportunidade de renegociar suas dívidas com descontos adicionais àqueles comumente ofertados no site. As ofertas especiais do Saldão ficam disponíveis por tempo limitado anualmente.',
    answers: [
      {
        id: 'b2c00be5-846d-4dcc-ac6c-0616b175dcbc',
        link: '',
        answer:
          'Durante o período do Saldão Recovery, você tem a oportunidade de renegociar suas dívidas com descontos adicionais àqueles comumente ofertados no site. As ofertas especiais do Saldão ficam disponíveis por tempo limitado anualmente.',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
    ],
    question: 'Quais as vantagens do Saldão Recovery?',
    component: 'faq',
    text_link: '',
    data_unique: '3c1a75f5-1d16-46ce-80c0-9664f982656e',
    answer_markdown: '',
    answer_after_link: '',
  },
  {
    id: '883e1fb3-3d23-4625-874e-19d4ac57d9c9',
    link: 'https://boletoexpress.gruporecovery.com/',
    answer:
      'Caso necessite uma segunda via ou o código digitável do seu boleto, você encontra no nosso',
    answers: [
      {
        id: '6284a96a-c46d-42c0-9487-b74a938c85e5',
        link: 'https://boletoexpress.gruporecovery.com/',
        answer:
          'Caso necessite uma segunda via ou o código digitável do seu boleto, você encontra no nosso',
        component: 'answers',
        text_link: 'portal',
        aria_label_link: '',
        answer_after_link:
          ', confirmando suas informações. Também é possível solicitar através do nosso Whatsapp 11 4765-8402 ou através do nosso App Recovery, disponível na Google Play e na Apple Store.',
      },
    ],
    question:
      'Como gerar a 2º via do boleto ou conseguir o código de barras para pagamento?',
    component: 'faq',
    text_link: 'portal',
    data_unique: '4259f0c8-8206-4f0e-81c9-88881e067bd2',
    answer_markdown: '',
    answer_after_link:
      ', confirmando suas informações. Também é possível solicitar através do nosso Whatsapp 11 4765-8402 ou através do nosso App Recovery, disponível na Google Play e na Apple Store.',
  },
  {
    id: 'f3e18799-784e-4007-b12e-2e4183f54221',
    link: 'https://boletoexpress.gruporecovery.com/',
    answer:
      'Ao finalizar um acordo, enviamos o boleto em seu e-mail. Recomendamos que certifique-se do recebimento, checando também em sua pasta de spam ou lixo eletrônico. Caso ainda não encontre, você também pode consultar seus boletos e solicitar uma segunda via',
    answers: [
      {
        id: 'e6e17a92-603c-4d60-9fe3-913e9f21bd9a',
        link: 'https://boletoexpress.gruporecovery.com/',
        answer:
          'Ao finalizar um acordo, enviamos o boleto em seu e-mail. Recomendamos que certifique-se do recebimento, checando também em sua pasta de spam ou lixo eletrônico. Caso ainda não encontre, você também pode consultar seus boletos e solicitar uma segunda via',
        component: 'answers',
        text_link: 'clicando aqui',
        aria_label_link:
          'Acesse o site boleto express para consultar seus boletos e solicitar uma segunda via',
        answer_after_link:
          ' e nos informando seu CPF ou CNPJ. Outras opções são os atendimentos via Whatsapp (11) 4765-8402 ou no App da Recovery, disponível na Google Play e na Apple Store.',
      },
    ],
    question: 'Tenho um acordo e não recebi o boleto. O que faço?',
    component: 'faq',
    text_link: 'clicando aqui',
    data_unique: '9598a2dd-8ef8-4f2f-8009-cc897f592539',
    answer_markdown: '',
    answer_after_link:
      'e nos informando seu CPF ou CNPJ. Outras opções são os atendimentos via Whatsapp (11) 4765-8402 ou no App da Recovery, disponível na Google Play e na Apple Store.',
  },
  {
    id: '5a232975-6e46-497d-a77e-2c44b1e6d246',
    link: '',
    answer:
      'A IResolve é uma securitizadora de créditos que, por meio de uma cessão de crédito, adquiriu o direito de cobrança e recebimento de operação(ões) que consumidores deviam à uma instituição financeira ou de varejista, e que hoje são administrados pela Recovery.',
    answers: [
      {
        id: 'afde217f-8ee1-46cb-a6dd-30fa9e19b0b1',
        link: '',
        answer:
          'A IResolve é uma securitizadora de créditos que, por meio de uma cessão de crédito, adquiriu o direito de cobrança e recebimento de operação(ões) que consumidores deviam à uma instituição financeira ou de varejista, e que hoje são administrados pela Recovery.',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
    ],
    question: 'O que é IResolve?',
    component: 'faq',
    text_link: '',
    data_unique: 'b0f298dc-b5b8-438f-a217-07d4c31dd0a2',
    answer_markdown: '',
    answer_after_link: '',
  },
  {
    id: 'fbba33ab-122c-4dc5-a511-93e40cc91672',
    link: '',
    answer: '',
    answers: [
      {
        id: '9132761a-81f2-4402-aa0a-3eaef0c5ac68',
        link: '',
        answer:
          'Oferecemos pagamento via boleto, à vista e parcelado. O boleto pode ser pago em qualquer agência bancária, lotérica, internet banking ou App do seu banco. ',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
      {
        id: 'fb3910ff-8f7c-450e-9575-ddad5d97466c',
        link: 'https://boletoexpress.gruporecovery.com/?utm_source=recovery&utm_medium=home&utm_campaign=pagamentos_clientes_pf_nova_faq&utm_content=link_nova-faq_acessar',
        answer:
          'Caso prefira, também aceitamos pagamentos via PIX, o mesmo pode ser feito escaneando o QR Code que vem impresso no boleto ou acessando o ',
        component: 'answers',
        text_link: 'Boleto Expresso',
        answer_after_link:
          ', onde é possível escanear o QR Code ou utilizar o copie e cole do código.',
      },
    ],
    question: 'Quais as formas de pagamento disponíveis?',
    component: 'faq',
    text_link: '',
    data_unique: 'cb0af5d1-aff3-4f61-a562-ce9183ff7c57',
    answer_markdown: '\n\n',
    answer_after_link: '',
  },
  {
    id: '6e1095df-da6a-4564-95af-c36e8ac45a87',
    link: '',
    answer:
      'Se o boleto da oferta que você negociou venceu, lembre-se de conferir até quanto tempo depois da data de vencimento é possível fazer o pagamento. Caso esse prazo tenha se esgotado, o acordo é perdido e será necessário fazer uma nova negociação com novos valores e datas para pagamento.',
    answers: [
      {
        id: '04cc48bc-c196-4bb3-81ee-f45d0a50158b',
        link: '',
        answer:
          'Se o boleto da oferta que você negociou venceu, lembre-se de conferir até quanto tempo depois da data de vencimento é possível fazer o pagamento. Caso esse prazo tenha se esgotado, o acordo é perdido e será necessário fazer uma nova negociação com novos valores e datas para pagamento.',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
    ],
    question: 'Meu boleto venceu, e agora? É possível renegociar?',
    component: 'faq',
    text_link: '',
    data_unique: '8c9cb8c1-290f-4efb-9a95-366d9925cd57',
    answer_markdown: '',
    answer_after_link: '',
  },
  {
    id: '501a019e-b68e-4f46-b0f9-20d547c4eab7',
    link: '',
    answer:
      'A regularização de restritivos SPC e Serasa ocorre automaticamente em até 5 (cinco) dias úteis após a identificação do pagamento da parcela do seu acordo.',
    answers: [
      {
        id: '8a4b3e45-6d90-42d4-9587-f6966336f007',
        link: '',
        answer:
          'A regularização de restritivos SPC e Serasa ocorre automaticamente em até 5 (cinco) dias úteis após a identificação do pagamento da parcela do seu acordo.',
        component: 'answers',
        text_link: '',
        answer_after_link: '',
      },
    ],
    question:
      'Após quantos dias do pagamento do meu acordo meu nome estará limpo?',
    component: 'faq',
    text_link: '',
    data_unique: 'd3797408-e657-4bef-a192-3a3ea6ecb182',
    answer_markdown: '',
    answer_after_link: '',
  },
  {
    id: '6b07073d-60f8-4032-bb1d-118b24d9d861',
    link: '',
    answer: '',
    answers: [
      {
        id: '3150bc35-337e-4616-9eb0-1bec05ff08d2',
        link: '',
        answer: 'A1 SOLUCOES EM RECUPERACAO DE CREDITO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'bb47199e-a79d-478d-86c7-8499eb46d31b',
        link: '',
        answer: 'AÇÃO CONTACT CENTER LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'e9ee7a8f-345b-4aaf-8836-e8ecf4050978',
        link: '',
        answer: 'ALMEIDA & ALMEIDA ASSESSORIA JURÍDICO EMPRESARIAL',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '3d4ee5eb-e7e7-495d-9260-82e772b5129e',
        link: '',
        answer: 'ANTONIO BRAZ E VANYA MAIA ADV. ASS.( HERDADOS )',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'b22eddf1-9982-4c08-bd25-8f2c9e2d608e',
        link: '',
        answer: 'ARAUJO E AUGUSTO ADVOGADOS ASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '052c20e8-542c-4126-b310-0ab476b78e87',
        link: '',
        answer: 'ARRUDA ALVIM ARAGÃO LINS & SATO ADV',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '0907e6b5-18b9-4691-9199-c56e7145ca0f',
        link: '',
        answer: 'AVAL ADMINISTRAÇÃO DE COBRANÇA E CADASTRO LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '6056b071-9a2e-4b5b-9b8c-20fbfe59600e',
        link: '',
        answer: 'BERNARDES, SILVA & RABELLO ADVOGADOS E CONSULTORES',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '240c8b97-ee79-48e1-985d-767da37ccc59',
        link: '',
        answer: 'BONATTO & BONATTO ADVOGADOS ASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5e87812a-832b-4c9d-997a-c25db9a0464e',
        link: '',
        answer: 'BP GESTÃO E RECUPERAÇÃO DE ATIVOS LTDA (ADV. BELLINATI)',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'db9dc66b-6554-4afe-8145-6053876aeb34',
        link: '',
        answer: 'BRASIL SALOMÃO E MATTHES ADVOCACIA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '04f05eab-4aa7-4927-ad65-da89a79ca869',
        link: '',
        answer: 'BRUNO VANDERLEI ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'f675bf5c-904f-40e7-9da6-58279c37b13e',
        link: '',
        answer: 'BULGARELLI ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5e0beb39-df76-43dd-9fd7-7c3c0c1c066a',
        link: '',
        answer: 'BULGARELLI SOCIEDADE DE ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '4d4acf65-c94c-4f25-a5dd-0e591ccc79ec',
        link: '',
        answer: 'BUTTOW E SILVA ADVOGADOS ASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'e0df83f3-75ea-4f24-bed4-83c24b465131',
        link: '',
        answer: 'CAPITAL ADMINISTRADORA DE CRÉDITO E COBRANÇA S/S L',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '55cefdab-93d1-48b8-ad94-3a843b7ca0b2',
        link: '',
        answer: 'CARDOZO DIAS SOCIEDADE DE ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '0400515a-09bb-423a-b326-ae3df3f9383b',
        link: '',
        answer: 'CARLOS MIRO E ADV. ASS. S/C',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'beb50241-5bd8-4376-a1f2-ef2ade96a1ae',
        link: '',
        answer: 'CDL RECIFE',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'f854a553-169f-4896-8647-7c184fa3dcde',
        link: '',
        answer: 'COBRANÇA INTERNA - GRB',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'e9d62f85-0413-4f21-8127-f546d2a6f2af',
        link: '',
        answer: 'COBRANÇA INTERNA – INTERVALOR',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ad52a723-5fbe-44ee-893a-95d9bc98ee71',
        link: '',
        answer: 'COMPARATO, NUNES, FEDERICI & PIMENTEL ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'd9b98276-63ac-49cd-b9f6-9f8ed9dfd1be',
        link: '',
        answer: 'CONCILIG TELEMARKETING E COBRANÇA LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'f910ecd2-7704-4ea9-aab1-565462ef7079',
        link: '',
        answer: 'CONSULCRED',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '9fdc323f-c7e2-46ca-8fd9-49148c9127d2',
        link: '',
        answer: 'CRC - CENTRAL DE RECUPERACAO DE CREDITO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '3a14a362-a4f0-4610-ac79-649ec8fc7724',
        link: '',
        answer: 'DAL BOSCO ADV. S/C',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '9331b520-f9c8-4478-a9e2-23243621092f',
        link: '',
        answer: 'DAVID E ANICETO STIEVANO ADV ASS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '545a1f61-21bb-4536-bf34-5015e5831844',
        link: '',
        answer: 'DECCACHE ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'cfc8cc87-f261-42b1-9fad-4bf6cb1cad68',
        link: '',
        answer: 'DNR (GRUPO NUNES E ROMERO)',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '1c9b18a1-001a-43fd-bd51-f42970adbfb4',
        link: '',
        answer: 'DOTTA, DONEGATTI, LACERDA & TORRES SOC.DE ADV.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '72ac1cbf-c10a-4370-8c12-4b4e3d3f118b',
        link: '',
        answer: 'ERNESTO BORGES E ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'b58e445a-b9b5-4f14-8db9-552754a3ed98',
        link: '',
        answer: 'FATTOR',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'd629ad54-5ecf-4788-ad5f-689b28c646da',
        link: '',
        answer: 'FERREIRA E CHAGAS ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'a61f164a-99c5-4418-b1e7-a000c113796c',
        link: '',
        answer: 'FRANCA & ASS. S/C ADV.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ccf14ed3-2938-4ea0-9665-bb14b58c1186',
        link: '',
        answer: 'FREIRE, GERBASI, BITTENCOURT E MACEDO SOC. DE ADV.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5987c468-d4d8-4479-a9d1-301a8f00b7dc',
        link: '',
        answer: 'GIAMPAULO SARRO ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'cc983ffb-a234-47cb-92fd-9f33e2a6455c',
        link: '',
        answer: 'GOES & NICOLADELLI ADVOGADOS ASSOC SC',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'd75d3498-2e4a-4810-bec2-d89711470d03',
        link: '',
        answer: 'GRB - RECEPTIVO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5b88a3c5-6321-4968-b85c-4a95819fe00d',
        link: '',
        answer: 'GRB SERVICES DO BRASIL LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '83277157-c9f2-4c34-b9e7-51cb173e291a',
        link: '',
        answer: 'HENRIQUE G. SCHROEDER ADV.ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '299cb5f0-28bb-46a1-85bc-0767ad0aff58',
        link: '',
        answer: 'INTERVALOR COBRANÇA GESTÃO LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '37307af0-ab53-492e-8fce-81c48bad8b40',
        link: '',
        answer: 'INTERVALOR RECEPTIVO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '9a1e3e81-7f55-4d4c-9030-ac901f4f72cc',
        link: '',
        answer: 'JORGE VICENTE LUZ ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5ed474f2-022d-4f84-bc52-08c8644f32eb',
        link: '',
        answer: 'JOSE CARLOS SKRZYSZOWSKI JR ADV ASSOC',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ba043ae3-e576-4cea-ba28-07aa6e463db4',
        link: '',
        answer: 'LARA ADVOGADOS ASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '0243886b-e8e3-4f81-b514-1a4db4ae95f3',
        link: '',
        answer: 'LEAL',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '0b267dd3-f8cf-49e0-9ad9-acab39525dae',
        link: '',
        answer: 'LESSA, PILLA, BRUSAMOLIN, KAVINSKI & ADVOGADOS ASS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ba07dda2-3d39-470c-aff3-beabc714a51b',
        link: '',
        answer: 'LIDER ASSESSORIA DE COBRANÇA LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'aa578582-9926-4864-a9cf-8555d97baec8',
        link: '',
        answer: 'LUCHESI ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '52c2561d-45c7-4643-a1d1-b725eacf88bc',
        link: '',
        answer: 'LUQUINI TAVEIROS ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '9150a983-433e-4a4c-96a5-550536995282',
        link: '',
        answer: 'MARCELO FERREIRA LIMA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'e36498b4-10d3-4577-a2a9-692768565c16',
        link: '',
        answer: 'MASCARENHAS BARBOSA ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'df4d564b-4b19-4572-96a1-93a864bce95d',
        link: '',
        answer: 'MEDINA & GUIMARAES ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ed22f3a5-cc0b-46fa-b5db-5a695ba68db7',
        link: '',
        answer: 'MELO, MARTINI E PARADA ADV ASS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ecc3bb14-3533-498e-b2b3-fc2eadb3641e',
        link: '',
        answer: 'N&N ASS. E CONS. EMPR. LTDA.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5c7f8127-9e86-45be-be16-c789924d6857',
        link: '',
        answer: 'NELSON PASCHOALOTTO ADVOGADOS AASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '8918419f-65e5-4c7b-b888-264b728764aa',
        link: '',
        answer: 'NUNES ROMERO ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'a8fcc548-3c2b-4bfd-97b7-9b3dc111bcf5',
        link: '',
        answer: 'OLIVEIRA & ANTUNES ADV. ASS. S/C',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '992c1b6d-7f23-44ab-92e1-690572f3c07d',
        link: '',
        answer: 'OLIVEIRA E RAMOS ADV. ASS.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '28bc8167-5e8e-4c7d-8892-24e76bd6ea02',
        link: '',
        answer: 'PASCHOALOTTO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '54046d74-b096-434e-959c-d3952e6bf86d',
        link: '',
        answer: 'PASCHOALOTTO - RECEPTIVO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '86d83bfb-44a7-42e1-a4bd-9c50fdc8c650',
        link: '',
        answer: 'PEREZ DE REZENDE ADVOCACIA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'f83b947f-9451-4fd7-ac7e-0ba2fcf9b762',
        link: '',
        answer: 'PERSONALCOB SERVIÇOS FINANCEIROS LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ae165235-398f-4516-9892-70ae824160b8',
        link: '',
        answer: 'PROCRED',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ebf2e705-8b91-45e0-a1c7-3719b38314d1',
        link: '',
        answer: 'QUERO QUITAR',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '19806e1d-81d2-4f83-9b04-78abbacc7f99',
        link: '',
        answer: 'R BRASIL SOLUCOES S.A',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '599ca1c0-713a-47f2-878f-a05b20563d28',
        link: '',
        answer: 'RAMOS E ZUANON ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '5861d9a7-49b2-4ca8-acfe-e0b01024eb61',
        link: '',
        answer: 'RBRASIL SOLUÇÕES',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'e7ee5d83-3060-4403-b597-e9fa1e6c35de',
        link: '',
        answer: 'REDEBRASIL GESTÃO DE ATIVOS LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '27a1ae0c-1ddf-40cb-90f3-7c04c777d3a5',
        link: '',
        answer: 'RENAC - RECUPERADORA NACIONAL DE CRÉDITO LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'dcf5fb01-1a15-4a1d-b94b-a23e9f028789',
        link: '',
        answer: 'SANCHEZ E SANCHEZ ADV.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'df80dac0-f047-4617-992c-f6339e2d6ffc',
        link: '',
        answer: 'SANCRED',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '4349074b-76ea-47ee-9b7e-ab1be87be792',
        link: '',
        answer: 'SANTIAGO ADVOGADOS ASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'c2a4e0b5-e869-4732-ad78-0fcae698e84a',
        link: '',
        answer: 'SERASA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '28d7fbbe-1300-48f8-9a92-aab1b5a4a860',
        link: '',
        answer: 'SERVICES ASSESSORIA E COBRANÇAS EIRELI',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '26913c74-40b0-4d42-8e2e-bf52ef6bcaf7',
        link: '',
        answer: 'SERVICES ASSESSORIA E COBRANÇAS EIRELI - DIGITAL',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'ae8f7b50-f216-4a65-9a7d-2dab0efa906f',
        link: '',
        answer: 'SEVILHA ANDRADE E ARRUDA SOCIEDADE DE AD',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'b00625c8-8d69-4795-bad7-e8c33d60e913',
        link: '',
        answer: 'SISCOM',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'd58ebff4-34a1-4a79-a3bc-a7560f42e196',
        link: '',
        answer: 'TEPEDINO, MIGLIORE, BEREZOWSKI E POPPA SOC. DE ADV',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '761bc7f0-c760-47c5-96a1-c18b82ba2576',
        link: '',
        answer: 'TORTORO, MADUREIRA E RAGAZZI SOCIEDADE DE ADVOGADO',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '70ab0f4e-3430-4ebe-879a-016a8c70504b',
        link: '',
        answer: 'TRC TABORDA RECUPERAÇÃO DE CREDITO LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'f654d9aa-5124-4da4-b95e-e5aa377c40a4',
        link: '',
        answer: 'VELLA PUGLIESE BUOSI E GUIDONI - ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'decf835b-add3-4e84-ab51-87d66df5f1e9',
        link: '',
        answer: 'VELLOSO CARNEIRO SOCIEDADE DE ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '53a7d5e1-8e7a-4b7d-852a-b20dce76d118',
        link: '',
        answer: 'VEZZI LAPOLLA E MESQUITA SOCIEDADE DE ADVOGADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '385797e5-7ff2-4300-af3c-7e54816479ca',
        link: '',
        answer: 'VIDIGAL DE OLIVEIRA ADV. ASS. S/S',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '1618d024-3bbc-43db-ade5-1026c14c3d4a',
        link: '',
        answer: 'VIDIGAL E MONTEZUMA ADVOGADOS ASSOCIADOS',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'cea8686c-5b6e-40a7-956b-7bdf3d9b2b08',
        link: '',
        answer: 'VLM',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: 'faff15a1-b550-438a-b668-d97c5e218384',
        link: '',
        answer: 'WAY BACK SOLUÇÕES EM COBRANÇA LTDA',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
    ],
    question: 'Quais são os escritórios de recuperação parceiros da Recovery?',
    component: 'faq',
    text_link: '',
    data_unique: '809d703f-4e56-4622-8741-b237d91b743a',
    answer_after_link: '',
  },
  {
    id: '5e9db509-9795-4c3d-bb2d-071440bb5d2b',
    link: '',
    answer: '',
    answers: [
      {
        id: '8672d855-de70-4682-a5b1-30a1bd7029d1',
        link: '',
        answer:
          'O Desenrola Brasil é um programa de renegociação de dívidas idealizado pelo Governo Federal que tem como objetivo diminuir o número de famílias endividadas no país e a retomada de acesso ao mercado de crédito.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '6c8e0f96-a9b8-43ec-8765-d98b01815b6a',
        link: '',
        answer:
          'De acordo o Ministério da Fazenda, poderão participar do programa pessoas físicas inadimplentes que se enquadrem em duas faixas de beneficiados: a faixa 1, das recebem até dois salários mínimos, tem dívidas de até R$5 mil e estavam negativadas em 31 de dezembro de 2022; e a faixa dois, das pessoas que tem dívidas bancárias, também negativadas em dezembro de 2022, mas com renda mensal de até R$ 20.000,00.',
        component: 'answers',
        text_link: '',
        aria_label_link: '',
        answer_after_link: '',
      },
      {
        id: '1d53615f-4da8-4145-9c10-b37f2eeb2c95',
        link: 'https://www.gruporecovery.com/blog-desenrola-brasil/',
        answer:
          'A renegociação das dívidas será on-line, em uma plataforma que ainda está em construção. A previsão é que a renegociação comece entre agosto e setembro de 2023. Para saber mais, leia nosso artigo sobre o',
        component: 'answers',
        text_link: 'Desenrola.',
        aria_label_link: '',
        answer_after_link: '',
      },
    ],
    question: 'Dúvidas sobre o Desenrola Brasil?',
    component: 'faq',
    text_link: '',
    data_unique: 'dc3fac45-5fdb-47dc-ba75-aecb080866eb',
    answer_after_link: '',
  },
]

export default faq
